export const breakpoints = {
  mobile: "0em",
  xs: "30em",
  sm: "48em",
  md: "62em",
  lg: "75em",
}
